module.exports = __webpack_public_path__ + "files/196643b01490b1b0b7fb29b7d7dcafd7.png";